import './inhaltsverzeichnis.css';
import React, { useState, useEffect } from "react";
import { ArrowDownUp } from 'lucide-react';
import { nummerAnzeige, nummerMitKuerzel, vergleicheNummer } from '../buecher';
import { useLocation, useNavigate } from "react-router-dom";
import { passtZurSuche, zerlegeNachTreffern } from '../suche';
import { loadLiederListe, subscribeLieder } from "../liederStore";

function Inhaltsverzeichnis() {
  const [lieder, setLieder] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('id');
  const navigate = useNavigate();
  const location = useLocation();
  const selectedCategory = new URLSearchParams(location.search).get('kategorie') || '';

  const openSong = (id) => {
    sessionStorage.setItem('scrollPosition', window.scrollY);
    sessionStorage.setItem('sortBy', sortBy);
    navigate(`/lied/${id}`);
  };

  const toggleSortBy = () => {
    setSortBy((prevSort) => (prevSort === 'name' ? 'id' : 'name'));
  };

  useEffect(() => {
    if (!sessionStorage.getItem('scrollPosition')) {
      window.scrollTo(0, 0);
    }
  }, []);

  useEffect(() => {
    loadLiederListe()
      .then(data => {
        setLieder(data);
        const scrollPos = sessionStorage.getItem('scrollPosition');
        if (scrollPos) {
          setTimeout(() => {
            window.scrollTo(0, parseInt(scrollPos));
            sessionStorage.removeItem('scrollPosition');
          }, 100);
        }
        const savedSortBy = sessionStorage.getItem('sortBy');
        if (savedSortBy) {
          setSortBy(savedSortBy);
          sessionStorage.removeItem('sortBy');
        }
      })
      .catch(err => console.error(err));
  }, []);

  useEffect(() => subscribeLieder(setLieder), []);

const visibleLieder = lieder
  .filter((lied) => {
    const matchesSearch = passtZurSuche(lied, searchTerm, nummerMitKuerzel(lied));
    const matchesCategory = !selectedCategory || lied.kategorie === selectedCategory;
    return matchesSearch && matchesCategory;
  })
  .sort((a, b) => {
    if (sortBy === 'id') {
      return vergleicheNummer(a, b);
    }
    return a.name.localeCompare(b.name, 'de', { sensitivity: 'base' });
  });

  function renderHighlightedName(name) {
    return zerlegeNachTreffern(name, searchTerm).map((teil, index) =>
      teil.treffer ? <span className='search_match' key={`${name}-${index}`}>{teil.text}</span> : teil.text
    );
  }

  return (
    <div id='inhaltsverzeichnis_body'>
      <div className='heading_box'>
        <h2>Inhaltsverzeichnis</h2>
      </div>
      <div className='search_box'>
        <input
          className='searchInput'
          value={searchTerm}
          onChange={(event) => setSearchTerm(event.target.value)}
          placeholder='Lied suchen...'
        />
        <button className='sort_toggle' onClick={toggleSortBy} title='Sortieren nach Nummer oder Titel' aria-label='Sortieren nach Nummer oder Titel'>
          <ArrowDownUp className='sort_icon' />
        </button>
      </div>
      {visibleLieder.map(lied => (
        <div className='titel_reihe' key={lied.id} onClick={() => openSong(lied.id)}>
          <div className='titelbtn'>
            <div>{renderHighlightedName(lied.name)}</div>
            <div>{nummerAnzeige(lied)}</div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Inhaltsverzeichnis;

